import { BaseWebSocketClient } from './baseWebSocketClient.js'

document.addEventListener('alpine:init', () => {
  Alpine.data('rosterSync', (config = {}) => ({
    // Configuration
    oauthUrls: config.oauthUrls || {},

    // State
    isConnected: false,
    isSyncing: false,
    syncStatus: 'idle', // idle, connecting, syncing, completed, error
    currentStep: '',
    provider: null,
    error: null,
    sections: [],

    // WebSocket client
    wsClient: null,

    init() {
      this.initWebSocket()
      this.checkExistingSync()
    },

    initWebSocket() {
      this.wsClient = new RosterSyncWebSocketClient(this)
    },

    // WebSocket event handlers
    updateSyncStatus(data) {
      this.isSyncing = data.is_syncing
      this.sections = data.sections_count || 0

      if (this.isSyncing) {
        this.syncStatus = 'syncing'
        this.currentStep = 'Sync in progress...'
      }
    },

    handleSyncStarted(data) {
      this.isSyncing = true
      this.syncStatus = 'syncing'
      this.provider = data.provider
      this.currentStep = data.message
      this.error = null
    },

    handleSyncProgress(data) {
      this.currentStep = data.message
    },

    handleSyncCompleted(data) {
      this.isSyncing = false
      this.syncStatus = 'completed'
      this.currentStep = data.message
      this.sections = data.sections_count || 0

      // Either navigate to where the server says (e.g. the new demo
      // class's assignment list) or refresh in place to show updated rosters.
      setTimeout(() => {
        if (data.redirect_url) {
          window.location.href = data.redirect_url
        } else {
          window.location.reload()
        }
      }, 2000)
    },

    handleSyncError(data) {
      this.isSyncing = false
      this.syncStatus = 'error'
      this.error = data.error
      this.currentStep = data.message
    },

    handleError(message) {
      this.syncStatus = 'error'
      this.error = message
      this.currentStep = message
      this.isSyncing = false
    },

    async startSync(provider) {
      if (this.isSyncing) {
        console.log('Sync already in progress')
        return
      }

      this.provider = provider
      this.syncStatus = 'connecting'
      this.currentStep = `Connecting to ${provider}...`
      this.error = null

      // Get OAuth URL for the provider
      const oauthUrl = this.oauthUrls[provider.toLowerCase()]
      if (!oauthUrl) {
        this.handleError(`No OAuth URL configured for ${provider}`)
        return
      }

      // Redirect to OAuth flow
      window.location.href = oauthUrl
    },

    checkExistingSync() {
      // Check if user is already in a sync process
      if (this.isSyncing) {
        this.syncStatus = 'syncing'
        this.currentStep = 'Sync in progress...'
      }
    },

    // Utility methods - simplified, most logic moved to template

    // Cleanup
    destroy() {
      if (this.wsClient) {
        this.wsClient.disconnect()
      }
    },
  }))

  // Roster Sync WebSocket client for real-time updates
  class RosterSyncWebSocketClient extends BaseWebSocketClient {
    constructor(alpineComponent = null) {
      super(null, alpineComponent) // assignmentId is null for roster sync
    }

    getWebSocketUrl() {
      return '/ws/roster-sync/'
    }

    onMessage(data) {
      if (!this.alpineComponent) return

      switch (data.type) {
        case 'sync_status':
          this.alpineComponent.updateSyncStatus(data.data)
          break
        case 'sync_started':
          this.alpineComponent.handleSyncStarted(data)
          break
        case 'sync_progress':
          this.alpineComponent.handleSyncProgress(data)
          break
        case 'sync_completed':
          this.alpineComponent.handleSyncCompleted(data)
          break
        case 'sync_error':
          this.alpineComponent.handleSyncError(data)
          break
        case 'pong':
          this.handlePong()
          break
        default:
          console.log('Unknown message type:', data.type)
      }
    }

    onOpen() {
      super.onOpen()
      if (this.alpineComponent) {
        this.alpineComponent.isConnected = true
        this.alpineComponent.reconnectAttempts = 0
        this.sendMessage({ type: 'get_sync_status' })
      }
    }

    onClose(event) {
      super.onClose(event)
      if (this.alpineComponent) {
        this.alpineComponent.isConnected = false
      }
    }

    sendMessage(message) {
      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        this.socket.send(JSON.stringify(message))
      }
    }
  }
})
